export default {
  fields: {
    addBook: {
      isShown: 'Afficher le @:book'
    },
    addPage: {
      isShown: 'Afficher la @:page'
    },
    addPostType: {
      name: '@:form.fields.postType.name',
      hasMultipleDates: 'Peut renseigner plusieurs dates ?',
      hasVenue: 'Peut renseigner un lieu ?'
    },
    collection: 'Collection',
    confirmPassword: 'Confirmer le mot de passe',
    currentPassword: 'Mot de passe actuel',
    description: 'Description',
    email: 'Adresse email',
    enabled: 'Activé',
    extraInfos: 'Informations supplémentaires',
    firstName: 'Prénom',
    format: 'Format',
    height: 'Hauteur',
    icon: 'Icon',
    importantColor: '@:importantColor',
    isAvailable: 'Disponible ?',
    isbn: 'ISBN',
    isShe: 'Féminisation',
    isShown: 'Afficher',
    lastName: 'Nom',
    landingPageBooksLimit: 'Nombre de livres sur la page d\'accueil',
    landingPageText: 'Texte d\'accueil',
    landingPageTextShort: 'Texte d\'accueil raccourci',
    mainTag: 'Tag principal',
    menu: {
      path: 'Chemin d\'accès'
    },
    name: 'Nom',
    newPassword: 'Nouveau mot de passe',
    otherContributors: 'autres contributeurs',
    page: 'Page',
    pagesCount: 'Nombre de pages',
    password: '@:password',
    plainPassword: '@:password',
    postType: {
      code: 'Code du type d\'actualité',
      name: 'Nom du type d\'actualité'
    },
    postTypes: 'Type d\'@:post',
    price: 'Prix',
    primaryColor: '@:primaryColor',
    publishDate: 'Date de publication',
    releaseDate: 'Date de sortie',
    resource: {
      name: 'Nom de la resource'
    },
    role: 'Role',
    roles: '@:(form.fields.role)s',
    secondaryColor: '@:secondaryColor',
    select_date: 'Choisir une date',
    select_datetime: '@:form.fields.select_date et l\'heure',
    select_collection: 'Choisir une @:collection',
    select_roles: 'Choisir un @:form.fields.role',
    selectBookTag: 'Choisir un @:tag',
    selectPostBooks: 'Choisir des @:books à associer',
    selectPostTypes: 'Choisir un type d\'@:post',
    shippingRate: 'Frais d\'envoi',
    showHelpMessages: 'Afficher les messages d\'aide',
    subTitle: 'Sous-titre',
    shopLink: 'Lien vers la boutique',
    shortDescription: '@:form.fields.description raccourcie',
    showInFooter: 'Affiché dans le bas de page',
    tag: {
      name: 'Nom du tag'
    },
    title: 'Titre',
    titleDisplay: 'Titre à afficher',
    updateBook: {
      isShown: 'Afficher le livre'
    },
    updatePage: {
      isShown: 'Afficher la page'
    },
    updatePostType: {
      name: '@:form.fields.postType.name',
      hasMultipleDates: 'Peut renseigner plusieurs dates ?',
      hasVenue: 'Peut renseigner un lieu ?'
    },
    username: 'Nom d\'@:user',
    width: 'Largeur',
    yourEmail: 'Votre addresse email'
  },
  validation: {
    collection: {
      required: 'Une collection est requise'
    },
    currentPassword: {
      required: 'Vous devez confirmer le mot de passe actuel'
    },
    dates: {
      valid: 'La date doit être valide'
    },
    description: {
      required: 'Un description est requise'
    },
    email: {
      required: 'Une adresse email est requise',
      email: 'L\'adresse email doit être valide'
    },
    format: {
      required: 'Un format est requis'
    },
    isbn: {
      required: 'Un ISBN est requis'
    },
    lastLogin: {
      betweenDate: 'L\'utilisateur doit s\'être connecté entre le {min} et le {max}'
    },
    maxLength: 'Longueur maximum de {maximum}',
    minLength: 'Longueur minimum de {min}',
    name: {
      required: 'Un @:name est requis'
    },
    newPassword: {
      required: '@:form.validation.password.required'
    },
    password: {
      invalidPasswordConfirmation: 'Les mots de passe doivent être identiques',
      required: 'Un mot de passe est requis',
      minLength: 'Le mot de passe doit comporter au moins {min} caractère'
    },
    plainPassword: {
      required: '@:form.validation.password.required',
      minLength: '@:form.validation.password.minLength'
    },
    releaseDate: {
      required: 'Une date de sortie est requise'
    },
    required: 'Requis',
    roles: {
      required: 'Un role est requis'
    },
    shopLink: {
      url: 'Le lien vers la boutique doit être valide'
    },
    shortDescription: {
      maxLength: 'La description raccourcie doit comporter au maximum {max} caractères'
    },
    title: {
      required: 'Un @:title est requis'
    },
    username: {
      minLength: 'Le nom de l\'utilisateur doit comporter au moins {min} caractêres',
      maxLength: 'Le nom de l\'utilisateur doit comporter au maximum {max} caractêres',
      required: 'Un nom d\'utilisateur est requis'
    }
  }
}
